import React from 'react';
import { convertLine } from './Convert';

/**
 * モーダルのbodyを編集
 *
 * @param body モーダルのbodyメッセージ
 */
export const editModalBody = (body: string) => {
  //改行\nが文字列に存在する場合、エスケープを外して表示する。
  const bodyMessage = convertLine(body);
  return bodyMessage === null ? (
    ''
  ) : (
    <div>
      <p className="paragraph">{bodyMessage}</p>
    </div>
  );
};
